import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { FC } from "react";

import { FilterOperator } from "../../../../types/table";

interface MatchContentButtonsProps {
  localOperator: FilterOperator;
  setLocalOperator: (value: React.SetStateAction<FilterOperator>) => void;
}

const MATCH_OPERATOR_OPTIONS: { value: FilterOperator; label: string }[] = [
  { value: "and", label: "And" },
  { value: "or", label: "Or" },
  { value: "isnot", label: "Is Not" },
];

export const MatchContentButtons: FC<MatchContentButtonsProps> = ({
  localOperator,
  setLocalOperator,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        fontWeight={500}
        sx={{ width: "45px" }}
      >
        Match
      </Typography>

      <ToggleButtonGroup
        value={localOperator}
        exclusive
        onChange={(_, v) => v != null && setLocalOperator(v)}
        size="small"
        fullWidth
        variant="segmented"
      >
        {MATCH_OPERATOR_OPTIONS.map(({ value, label }) => (
          <ToggleButton key={value} value={value}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};
